import React from 'react';
import { motion } from 'framer-motion';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}
interface SalesButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  size?: 'default' | 'large';
}
const CHECKOUT_URL = 'https://optilatammarket.com/cart/42581175631970:1';
export function SalesButton({
  children,
  onClick,
  className = '',
  size = 'default'
}: SalesButtonProps) {
  const sizeClasses = size === 'large' ? 'px-10 py-5 text-xl' : 'px-8 py-4 text-lg';
  const handleClick = () => {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart', {
        content_ids: ['42581175631970'],
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
      window.fbq('track', 'InitiateCheckout', {
        content_ids: ['42581175631970'],
        content_type: 'product',
        value: 6.39,
        currency: 'USD',
        num_items: 1
      });
    }
    // Small delay ensures Pixel events are queued before browser navigates
    setTimeout(() => {
      window.open(CHECKOUT_URL, '_blank');
    }, 150);
    if (onClick) onClick();
  };
  return <motion.button onClick={handleClick} className={`
        ${sizeClasses}
        bg-[#c9a227] hover:bg-[#d4a017] 
        text-[#1a2744] font-bold 
        rounded-lg shadow-lg
        transition-colors duration-200
        ${className}
      `} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0 0 0 0 rgba(201, 162, 39, 0.4)', '0 0 0 10px rgba(201, 162, 39, 0)', '0 0 0 0 rgba(201, 162, 39, 0)']
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  }} data-id="element-336">
      {children}
    </motion.button>;
}